import React, { useState } from 'react';
import { contactService } from '../../../services/contactService';

const ContactForm = () => {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        subject: '',
        categories: '',
        message: '',
        consent: false
    });
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [message, setMessage] = useState('');

    const handleChange = (e) => {
        const { name, value, type, checked } = e?.target;
        setFormData(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value
        }));
    };

    const handleSubmit = async (e) => {
        e?.preventDefault();
        setIsSubmitting(true);
        setMessage('');
        
        try {
            // Map form data to contact service format
            const requestData = {
                user_id: null, // Anonymous submission
                name: formData?.name?.trim(),
                email: formData?.email?.trim(),
                subject: formData?.subject?.trim(),
                message: formData?.message?.trim(),
                supportType: formData?.categories === 'General Inquiry' ? 'other' :
                           formData?.categories === 'Support Request' ? 'technical_issue' :
                           formData?.categories === 'Sales Question' ? 'billing_account' :
                           formData?.categories === 'Technical Issue' ? 'technical_issue' :
                           formData?.categories === 'Feedback' ? 'other' : 'other',
                consent: formData?.consent
            };

            console.log('Submitting contact request:', requestData);

            // Use the existing contactService instead of API endpoint
            const { data, error } = await contactService?.submitContactRequest(requestData);
            
            if (error) {
                console.error('Contact form submission error:', error);
                setMessage('Error: ' + error);
            } else {
                setMessage('Form submitted successfully! Your request has been received and we will get back to you soon.');
                setFormData({
                    name: '',
                    email: '',
                    subject: '',
                    categories: '',
                    message: '',
                    consent: false
                });
            }
        } catch (error) {
            setMessage('Error submitting form. Please try again.');
            console.error('Form submission error:', error);
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <div className="form-container" style={{
            maxWidth: '600px',
            margin: '0 auto',
            padding: '20px',
            fontFamily: 'Segoe UI, Tahoma, Geneva, Verdana, sans-serif'
        }}>
            <h2 style={{
                color: '#2c3e50',
                marginBottom: '8px',
                fontSize: '1.8rem',
                fontWeight: '700'
            }}>Send us a message</h2>
            <p style={{
                color: '#7f8c8d',
                marginBottom: '30px',
                fontSize: '1rem',
                lineHeight: '1.5'
            }}>Contact us for any inquiries or support</p>
            {message && (
                <div className={`message ${message?.includes('success') ? 'success' : 'error'}`} style={{
                    padding: '15px',
                    borderRadius: '8px',
                    marginBottom: '20px',
                    backgroundColor: message?.includes('success') ? '#d4edda' : '#f8d7da',
                    color: message?.includes('success') ? '#155724' : '#721c24',
                    border: `1px solid ${message?.includes('success') ? '#c3e6cb' : '#f5c6cb'}`
                }}>
                    {message}
                </div>
            )}
            <form onSubmit={handleSubmit} style={{
                backgroundColor: 'white',
                padding: '40px',
                borderRadius: '12px',
                boxShadow: '0 4px 20px rgba(0,0,0,0.08)'
            }}>
                <div style={{
                    display: 'grid',
                    gridTemplateColumns: '1fr 1fr',
                    gap: '20px',
                    marginBottom: '24px'
                }}>
                    <div style={{ marginBottom: '24px' }}>
                        <label style={{
                            display: 'block',
                            marginBottom: '8px',
                            fontWeight: '600',
                            color: '#2c3e50',
                            fontSize: '14px'
                        }}>
                            Name <span style={{ color: '#e74c3c' }}>*</span>
                        </label>
                        <input 
                            type="text"
                            name="name"
                            value={formData?.name}
                            onChange={handleChange}
                            placeholder="Enter your name"
                            required
                            style={{
                                width: '100%',
                                padding: '14px 16px',
                                border: '2px solid #e1e8ed',
                                borderRadius: '8px',
                                fontSize: '15px',
                                transition: 'all 0.3s ease',
                                backgroundColor: '#fafbfc',
                                fontFamily: 'inherit'
                            }}
                        />
                    </div>

                    <div style={{ marginBottom: '24px' }}>
                        <label style={{
                            display: 'block',
                            marginBottom: '8px',
                            fontWeight: '600',
                            color: '#2c3e50',
                            fontSize: '14px'
                        }}>
                            Email <span style={{ color: '#e74c3c' }}>*</span>
                        </label>
                        <input 
                            type="email"
                            name="email"
                            value={formData?.email}
                            onChange={handleChange}
                            placeholder="Enter your email address"
                            required
                            style={{
                                width: '100%',
                                padding: '14px 16px',
                                border: '2px solid #e1e8ed',
                                borderRadius: '8px',
                                fontSize: '15px',
                                transition: 'all 0.3s ease',
                                backgroundColor: '#fafbfc',
                                fontFamily: 'inherit'
                            }}
                        />
                    </div>
                </div>

                <div style={{ marginBottom: '24px' }}>
                    <label style={{
                        display: 'block',
                        marginBottom: '8px',
                        fontWeight: '600',
                        color: '#2c3e50',
                        fontSize: '14px'
                    }}>
                        Subject <span style={{ color: '#e74c3c' }}>*</span>
                    </label>
                    <input 
                        type="text"
                        name="subject"
                        value={formData?.subject}
                        onChange={handleChange}
                        placeholder="Enter the subject of your message"
                        required
                        style={{
                            width: '100%',
                            padding: '14px 16px',
                            border: '2px solid #e1e8ed',
                            borderRadius: '8px',
                            fontSize: '15px',
                            transition: 'all 0.3s ease',
                            backgroundColor: '#fafbfc',
                            fontFamily: 'inherit'
                        }}
                    />
                </div>

                <div style={{ marginBottom: '24px' }}>
                    <label style={{
                        display: 'block',
                        marginBottom: '8px',
                        fontWeight: '600',
                        color: '#2c3e50',
                        fontSize: '14px'
                    }}>
                        Category <span style={{ color: '#e74c3c' }}>*</span>
                    </label>
                    <select 
                        name="categories"
                        value={formData?.categories}
                        onChange={handleChange}
                        required
                        style={{
                            width: '100%',
                            padding: '14px 16px',
                            border: '2px solid #e1e8ed',
                            borderRadius: '8px',
                            fontSize: '15px',
                            transition: 'all 0.3s ease',
                            backgroundColor: '#fafbfc',
                            fontFamily: 'inherit',
                            backgroundImage: "url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 20 20'%3e%3cpath stroke='%236b7280' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.5' d='m6 8 4 4 4-4'/%3e%3c/svg%3e\")",
                            backgroundPosition: 'right 12px center',
                            backgroundRepeat: 'no-repeat',
                            backgroundSize: '16px',
                            paddingRight: '40px',
                            appearance: 'none'
                        }}
                    >
                        <option value="">Select a category</option>
                        <option value="General Inquiry">General Inquiry</option>
                        <option value="Support Request">Support Request</option>
                        <option value="Sales Question">Sales Question</option>
                        <option value="Technical Issue">Technical Issue</option>
                        <option value="Feedback">Feedback</option>
                        <option value="Other">Other</option>
                    </select>
                </div>

                <div style={{ marginBottom: '24px' }}>
                    <label style={{
                        display: 'block',
                        marginBottom: '8px',
                        fontWeight: '600',
                        color: '#2c3e50',
                        fontSize: '14px'
                    }}>
                        Message <span style={{ color: '#e74c3c' }}>*</span>
                    </label>
                    <textarea 
                        name="message"
                        value={formData?.message}
                        onChange={handleChange}
                        placeholder="Enter your message here..."
                        maxLength={2000}
                        required
                        style={{
                            width: '100%',
                            padding: '14px 16px',
                            border: '2px solid #e1e8ed',
                            borderRadius: '8px',
                            fontSize: '15px',
                            transition: 'all 0.3s ease',
                            backgroundColor: '#fafbfc',
                            fontFamily: 'inherit',
                            resize: 'vertical',
                            minHeight: '120px'
                        }}
                    />
                    <div style={{
                        fontSize: '12px',
                        color: '#666',
                        textAlign: 'right',
                        marginTop: '5px'
                    }}>
                        {formData?.message?.length} / 2000 characters
                    </div>
                </div>

                <div style={{
                    display: 'flex',
                    alignItems: 'flex-start',
                    gap: '12px',
                    marginBottom: '24px'
                }}>
                    <input 
                        type="checkbox"
                        name="consent"
                        checked={formData?.consent}
                        onChange={handleChange}
                        required
                        style={{
                            width: 'auto',
                            margin: '0',
                            transform: 'scale(1.2)',
                            accentColor: '#17394B'
                        }}
                    />
                    <label style={{
                        margin: '0',
                        fontWeight: '500',
                        color: '#2c3e50',
                        lineHeight: '1.4',
                        cursor: 'pointer'
                    }}>
                        I consent to the processing of my personal information for the purpose of responding to my inquiry. <span style={{ color: '#e74c3c' }}>*</span>
                    </label>
                </div>

                <button 
                    type="submit" 
                    disabled={isSubmitting}
                    style={{
                        background: '#17394B',
                        color: 'white',
                        border: 'none',
                        padding: '16px 32px',
                        borderRadius: '8px',
                        fontSize: '16px',
                        fontWeight: '600',
                        cursor: isSubmitting ? 'not-allowed' : 'pointer',
                        transition: 'all 0.3s ease',
                        width: '100%',
                        fontFamily: 'inherit',
                        opacity: isSubmitting ? 0.7 : 1
                    }}
                >
                    {isSubmitting ? 'Submitting...' : 'Send Message'}
                </button>
            </form>
        </div>
    );
};

export default ContactForm;